<template>
  <div class="db-start-wrapper">
    <div v-html="startTitle" class="db-title"></div>

    <div class="row db-start-image-wrapper">
      <div
        class="col-10 col-sm-6 offset-1 offset-sm-0 db-image-frame db-img-rot-minus-4"
      >
        <img src="../assets/room2.jpg" />
      </div>
    </div>
    <div class="db-textblock" style="font-family: NexaRustSansBlack1;">
      <p>
        Innerhalb weniger Minuten führen wir Sie von der groben Planung zur
        individuellen Angebotsanfrage.
      </p>
      <p>Also: Kurz das Werkzeug beiseitelegen und los geht’s!</p>
    </div>

    <div class="row start-btn-wrapper">
      <div class="col-10 offset-1">
        <button
          @click="setCurrentState('questionaire')"
          class="db-btn start-btn"
        >
          Jetzt loslegen
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    startTitle() {
      return this.$store.state.surveyJSON.dbCustomData.startTitle;
    },
  },

  mounted() {
    window.hj("vpv", "/startseite");
    console.log("hj /startseite");
  },

  methods: {
    setCurrentState() {
      this.$store.commit("setActivePage", "questionaire");
    },
  },
};
</script>

<style>
/*
.start-button {
  background-color: #008035;
  color: #fff;
  border: 0;
  font-size: 30px;
  width: 100%;
  padding: 10px 10px;
  border-radius: 999px;
}

.button-arrow {
  font-size: 60px;
  line-height: 20px;
}
*/
</style>
